'use client';

import { useMemo } from 'react';

import { Typography, IcOrder, BottomSheet, useOverlay } from '@bgzt/ui';
import { FilterValue } from '~/apis/search';

import styles from './SortFilter.module.css';

type Props = {
  totalAmount: number;
  onSortChange?: (sort?: string) => void;
  selectedValue?: string;
  sortData?: FilterValue[];
};

export const SortFilter = ({ totalAmount, onSortChange, selectedValue = '', sortData = [] }: Props) => {
  const overlay = useOverlay();
  const SELECTED_LABEL = useMemo(() => {
    if (!selectedValue) return sortData.filter((data) => data._default)[0]?.name;

    return sortData.find(({ value }) => value === selectedValue)?.name ?? '';
  }, [selectedValue, sortData]);

  const handleSortClick = (value?: string) => {
    onSortChange?.(value);
    globalThis.window.scrollTo({ top: 0 });
  };

  const handleSortDialogClick = () => {
    overlay.open(({ isOpen, close }) => (
      <BottomSheet
        isOpen={isOpen}
        onClose={() => {
          close();
        }}
      >
        <div>
          {sortData.map(({ value, name }) => (
            <button
              className={styles.sortDialogButton}
              key={value}
              onClick={() => {
                handleSortClick(value);
                close();
              }}
            >
              <Typography variant="L2" color={value === selectedValue ? 'red-500' : 'gray-900'}>
                {name}
              </Typography>
            </button>
          ))}
        </div>
        <BottomSheet.Footer showTopGradient />
      </BottomSheet>
    ));
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.totalAmountContainer}>
          <Typography variant="L10" color="gray-900">
            상품
          </Typography>
          <Typography variant="L9" color="gray-900">
            {totalAmount.toLocaleString()}
          </Typography>
        </div>
        <button className={styles.sortButton} onClick={handleSortDialogClick}>
          <Typography variant="L10" color="gray-900">
            {SELECTED_LABEL}
          </Typography>
          <IcOrder size={12} fill="#191919" />
        </button>
      </div>
    </>
  );
};
